import { FormattedMessage } from "react-intl";
import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";
import GlobalMessages from "../../messages/messages";

export function RenderPageNumbers({ currentPage, pageNumbers, onClick }) {
  const pageNumbersElements = [];

  if (pageNumbers >= 9) {
    for (let i = 0; i < 3; i++) {
      pageNumbersElements.push(
        <ListItem
          key={`first-part-${i}`}
          id={i}
          currentPage={currentPage}
          onClick={onClick}
        >
          {i + 1}
        </ListItem>,
      );
    }

    pageNumbersElements.push(
      <FormattedMessage key="dots-1" {...GlobalMessages.dots} />,
    );

    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      // Start
      let offset = 0;
      if (currentPage < 4) {
        offset = 4 - currentPage;
      }

      // End
      const delta = pageNumbers - currentPage;
      if (delta < 5) {
        offset = -5 + delta;
      }

      // Result
      const value = i + offset;

      pageNumbersElements.push(
        <ListItem
          key={`second-part-${value}`}
          id={value}
          currentPage={currentPage}
          onClick={onClick}
        >
          {value + 1}
        </ListItem>,
      );
    }

    pageNumbersElements.push(
      <FormattedMessage key="dots-2" {...GlobalMessages.dots} />,
    );

    for (let i = pageNumbers - 3; i < pageNumbers; i++) {
      pageNumbersElements.push(
        <ListItem
          key={`third-part-${i}`}
          id={i}
          currentPage={currentPage}
          onClick={onClick}
        >
          {i + 1}
        </ListItem>,
      );
    }
  } else {
    for (let i = 0; i < pageNumbers; i++) {
      pageNumbersElements.push(
        <ListItem
          key={`small-pagenumber-list-${i}`}
          id={i}
          currentPage={currentPage}
          onClick={onClick}
        >
          {i + 1}
        </ListItem>,
      );
    }
  }

  return pageNumbersElements;
}

RenderPageNumbers.propTypes = {
  currentPage: PropTypes.number,
  pageNumbers: PropTypes.number,
  onClick: PropTypes.func,
};

function selectedPage({ theme, id, currentPage }) {
  if (id === currentPage) {
    return css`
      background-color: ${theme.selectedColor};
    `;
  }
  return css``;
}

const ListItem = styled.div`
  ${selectedPage};

  display: flex;
  padding: 15px;
  padding-top: 5px;
  padding-bottom: 5px;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.hoverColor};
  }
`;
